import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Camera, Clock } from 'lucide-react';
import { getDrafts } from '../lib/offline';

const CYCLE_MS = 60 * 60 * 1000;

// Banner flotante mientras haya borradores de tracking por enviar
export const DraftsBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [info, setInfo] = useState({ count: 0, start: null });
  const [now, setNow] = useState(Date.now());

  const refresh = async () => {
    try {
      const drafts = await getDrafts();
      setInfo({
        count: drafts.length,
        start: drafts.length ? Math.min(...drafts.map(d => new Date(d.capturedAt).getTime())) : null,
      });
    } catch { /* noop */ }
  };

  useEffect(() => {
    refresh();
    window.addEventListener('drafts-changed', refresh);
    const t = setInterval(() => { setNow(Date.now()); }, 15000);
    return () => { window.removeEventListener('drafts-changed', refresh); clearInterval(t); };
  }, []);
  useEffect(() => { refresh(); }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!info.count || location.pathname === '/app/drafts') return null;
  const remaining = info.start != null ? info.start + CYCLE_MS - now : null;
  const expired = remaining != null && remaining <= 0;
  const mins = remaining != null ? Math.max(0, Math.floor(remaining / 60000)) : null;

  return (
    <button
      onClick={() => navigate('/app/drafts')}
      className={`w-full px-4 py-2.5 flex items-center justify-center gap-2 text-[12.5px] font-medium text-white ${expired ? 'bg-[#dc2626]' : 'bg-[#0f1d6f]'}`}
      data-testid="drafts-banner"
    >
      <Camera size={13}/> {info.count} captura(s) por enviar
      <span className="inline-flex items-center gap-1 opacity-90"><Clock size={12}/>{expired ? 'ciclo de 1 h vencido' : `quedan ${mins} min`}</span>
      <span className="underline underline-offset-2">Abrir</span>
    </button>
  );
};
